<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-select v-model="queryParam.batchId" @change="getPage({pageNum: 1})" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">
          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
      <!--      <div class="text-right" style="margin-top: 10px;">-->
      <!--      </div>-->
      <div class="text-right" style="margin-top: 10px;">
        <el-button v-if="isShowImport" @click="downloadTemp" type="text" style="color: #1890FF;margin-left: 0px;">下载模板</el-button>
        <el-button v-if="isShowImport" type="primary" @click="exam()">导入考生</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium">
        <el-table-column prop="id" label="序号">
          <template slot-scope="scope">
            {{1+page.pageSize*(page.pageNum-1)+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column prop="addUserName" label="导入姓名"></el-table-column>
        <el-table-column prop="addTime" label="导入时间">
          <template slot-scope="scope">
            {{scope.row.addTime?$moment(scope.row.addTime).format('YYYY-MM-DD HH:mm:ss'):''}}
          </template>
        </el-table-column>
        <el-table-column prop="payStatus" label="考生明细">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="$router.push(`/order/recording-detail?batchId=${scope.row.batchId}&batchRecordLogId=${scope.row.importLogId}`)">
              已导入{{scope.row.importNum}}人
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="unfinishNum" label="未完成录制人数"></el-table-column>
        <el-table-column prop="finishNum" label="已完成录制人数"></el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="导入考生数据" v-if="examForm.show" :visible.sync="examForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Exam :row="examForm.row" @close="onClose"></Exam>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%">
      <p>当前进度</p>
      <div style="text-align: center">
        <el-progress type="circle" :percentage="percent"></el-progress>
      </div>
      <div v-if="currentNum && totalNum" style="width: 100%;text-align: center;margin-top: 10px;">
        当前数据进度：
        <span>{{currentNum}}</span>/<span>{{totalNum}}</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Exam from './batchRecird-import'

export default {
  name: 'batch-recording',
  components: { Exam },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { pageSize: 20, pageNum: 1 },
      page: { pageSize: 20, pageNum: 1 },
      examForm: { show: false, row: null },
      batchList: [],
      currentUserInfo: this.$store.state.currentUserInfo,
      isShowImport: false,
      isShowAdmin: false,
      taskInterval: 0,
      currentBatch: {},
      dialogVisible: false,
      percent: null,
      totalNum: '',
      currentNum: ''
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (this.$route.query.batchId) {
      this.queryParam.batchId = this.$route.query.batchId
    } else {
      if (!this.queryParam.batchId) {
        this.queryParam.batchId = this.batchList[0].batchId
      }
    }
    let roleList = this.currentUserInfo.roleList
    for (let i in roleList) {
      let role = roleList[i]
      if (role.roleName === 'import') {
        this.isShowImport = true
      } else if (role.roleName === 'admin') {
        this.isShowAdmin = true
      }
    }
    await this.getPage()
    this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        for (let i in this.batchList) {
          let batch = this.batchList[i]
          if (batch.batchId === this.queryParam.batchId) {
            this.currentBatch = batch
          }
        }
        this.dialogVisible = false
        this.examForm.show = false
        this.examForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiBatchRecord.getPage(this.queryParam)
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async onClose (event) {
      await this.getPage({ batchId: event.batchId })
      if (event.taskName) {
        this.getTaskInfo(event.taskName)
      }
    },
    async exportExcel (row) {
      try {
        await this.$HTTP.ApiExamImport.exportExcel(this.queryParam)
        this.getTaskInfo('export_exam_list')
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async getTaskInfo (taskName) {
      this.taskInterval = setInterval(async () => {
        try {
          let taskInfo = await this.$HTTP.ApiExamImport.getTaskInfo(taskName)
          this.percent = taskInfo.percent
          this.totalNum = taskInfo.totalNum
          this.currentNum = taskInfo.currentNum
          if (taskInfo) {
            if (taskInfo.status === 0 && taskInfo.status !== 2) {
              this.dialogVisible = true
            }
            if (taskInfo.errorExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.errorExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.successExcelUrl) {
              clearInterval(this.taskInterval)
              let fileUrl = await this.$HTTP.ApiOss.signatureUrl(taskInfo.successExcelUrl, 'temp')
              this.Tool.downloadFile(fileUrl)
              await this.getPage()
            } else if (taskInfo.percent >= 100) {
              clearInterval(this.taskInterval)
              this.$message({ type: 'success', message: '导入成功' })
              await this.getPage()
            } else if (taskInfo.status >= 2) {
              clearInterval(this.taskInterval)
              if (taskInfo.errMsg) {
                this.$message({ type: 'error', message: taskInfo.errMsg })
              }
              await this.getPage()
            }
          } else {
            clearInterval(this.taskInterval)
          }
          if (taskInfo.percent >= 100) {
            this.dialogVisible = false
          }
        } catch (e) {
          clearInterval(this.taskInterval)
        }
      }, 2000)
    },
    async exam (row) {
      this.examForm.show = true
      if (row) {
        this.examForm.row = row
      } else {
        this.examForm.row = null
      }
    },
    async downloadTemp () {
      let url = 'https://zego-davinci-public.oss-cn-shanghai.aliyuncs.com/test/kaoji/template/batch_record_import_model.xlsx'
      let fileUrl = await this.$HTTP.ApiOss.signatureUrl(url, 'public-read')
      this.Tool.downloadFile(fileUrl)
    }
  }
}
</script>
